/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personas_System_Prompt_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Enter the system prompt that defines this persona's behavior..." |
*
* @param {Personas_System_Prompt_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const personas_system_prompt_placeholder = /** @type {((inputs?: Personas_System_Prompt_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personas_System_Prompt_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie den System-Prompt ein, der das Verhalten dieser Persona definiert...")
	return /** @type {LocalizedString} */ ("Enter the system prompt that defines this persona's behavior...")
});